
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcks/self-proposal",
      function () {
        return require("private-next-pages/bcks/self-proposal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcks/self-proposal"])
      });
    }
  